export const popupHelper = (context, message, navigateTo) => ({
  context,
  message,
  navigateTo,
});

/* prevents 'Prefer default export error flag
    please remove @dummyHelper if more exports are made
*/
export const dummyHelper = 'Nothing';
